import DataTable from 'Components/DataTable';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import BlockWrapper from 'Components/_NewElements/BlockWrapper';
import { ISatisfactionWithCare, satisfactionWithCare, isLocaleKey } from 'neuro-schemas';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';
import { MyServiceContext } from '../..';

export const SatisfactionWithCare = (): React.JSX.Element => {
  const myServContext = React.useContext(MyServiceContext);
  const { editing, setEditingData, locale, viewing, setViewingObj, setEditingObj } = myServContext;
  const swcData = (editing?.data || viewing?.data) as ISatisfactionWithCare & IControlProps;
  const swcLocales = satisfactionWithCare.localizations;
  const useLocale = isLocaleKey(locale) ? locale : 'fi';
  const onChangeSurveyForm = (values: TOnChangeValues): void => {
    const field = Object.keys(values)[0];
    const value = Object.values(values)[0];
    setEditingData?.({
      ...swcData,
      [field]: value,
    });
  };

  return (
    <>
      <BlockWrapper
        title={viewing ? formatPartialDate(swcData.date) : undefined}
        buttons={
          viewing
            ? [
                {
                  title: 'general.edit',
                  onClick: () => {
                    setViewingObj(null);
                    setEditingObj({ type: 'satisfactionWithCare', data: swcData });
                  },
                },
              ]
            : undefined
        }
      >
        {!viewing && (
          <FormRow title={'general.date'} headerWidth={4.2}>
            <InputHandler
              name="date"
              type="PartialDate"
              dateDefault="now"
              formData={{
                document: { date: swcData?.date },
                onChange: onChangeSurveyForm,
              }}
              editing={!!editing}
            />
          </FormRow>
        )}
        <div style={{ width: '60%', marginBottom: '2rem', marginTop: viewing ? '6rem' : undefined }}>
          <DataTable
            headers={['', '']}
            data={{
              rowData: [
                [
                  swcLocales[useLocale]['title'],
                  <InputHandler
                    key="satisfactionWithCare"
                    name="satisfactionWithCare"
                    type="Radio"
                    editing={!!editing}
                    options={['satisfied', 'somewhatSatisfied', 'dissatisfied']}
                    optionFormatter={o => swcLocales[useLocale][`opts.${o}`]}
                    formData={{
                      document: { satisfactionWithCare: swcData?.satisfactionWithCare },
                      onChange: onChangeSurveyForm,
                    }}
                  />,
                ],
                [
                  swcLocales[useLocale]['remarkableHarmFromCare'],
                  <InputHandler
                    key="harm"
                    name="remarkableHarmFromCare"
                    type="Radio"
                    editing={!!editing}
                    options={['yes', 'no']}
                    optionFormatter={o => swcLocales[useLocale][`opts.${o}`]}
                    formData={{
                      document: { remarkableHarmFromCare: swcData?.remarkableHarmFromCare },
                      onChange: onChangeSurveyForm,
                    }}
                  />,
                ],
              ],
              rowStyle: viewing ? undefined : [{ rowAlign: 'top' }, { rowAlign: 'top' }],
            }}
          />
        </div>
      </BlockWrapper>
    </>
  );
};
